// extracted by mini-css-extract-plugin
export default {"root":"MenuButton_root__l22fA"};